/* eslint react/prop-types: 0 */
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

const Container = styled.div`
  display: flex;
  margin: ${tokens.spacer.x4} 0;
  color: ${tokens.color.text_disabled};
  ${tokens.text('subtitle3')}
  align-items: center;
`;

const Line = styled.div`
  flex: 1 1 auto;
  height: 1px;
  background-color: ${tokens.color.text_disabled};
`;

const Text = styled.div`
  flex-shrink: 1;
  padding: 0 ${tokens.spacer.x1};
  white-space: nowrap;
  color: ${tokens.color.text_disabled};
`;

export const TextHorizontalRule = ({ message, className = '' }) => {
  return (
    <Container className={className}>
      <Line />
      <Text>{message}</Text>
      <Line />
    </Container>
  );
};
